<template>
 <outline-button
    class="submission-lightbox-close"
    iconOnly
    noBorder
    buttonIcon="close"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'submission-lightbox-close',
};
</script>

<style lang="scss">
.submission-lightbox-close {
    position: absolute;
    right: $size-right-hero-video-close-button;
    top: $size-top-hero-video-close-button;
    background: $color-background-close-button;
    border-radius: 50%;
    .rb-button-outline {
      &__icon {
        height: $size-height-hero-video-close-button;
        width: $size-width-hero-video-close-button;
        &--icon {
          font-size: $size-font-size-hero-video-close-button;
        }
      }
    }
  }
</style>
